module.exports = __webpack_public_path__ + "static/scale-model-of-live-action-escapes-in-worcester-massachusetts-a8298419e7ad2fbb30ff754e5025d0e0.png";